import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import * as accountActions from './store/accountActions';
import { setRedirectUrl, isOrgAdminRestricted } from '../../modules/session';
import { Common } from '../../components';
import ContextMenu from '../../components/common/grid/contextMenu';
import { Button, Icon, Menu, Modal, Popup, Table } from 'semantic-ui-react';
import AccountStatus from './status';
import './index.css';
import {
  tabs,
  i18nKeys,
  adminColumns,
  getAdminAccessInfo,
  orgAdminsAvailableFilters,
  hasActiveOrPastSystemAdminMembership,
  RETENTION_ENTITY
} from './constants';
import { bindActionCreators } from 'redux';
import { Record } from '../../modules/bin/utility';
import Spinner from '../../components/common/spinner';
import InviteAdmin from './inviteAdmin';
import RecordResultMessage from '../../components/common/recordResult';
import clear from '../../components/clear';
import { impersonateAdmin } from '../../modules/session';
import * as generalActions from '../../modules/general';
import { gridKeys } from '../../constants/gridKeys';
import {
  RetentionPanel,
  DeidentifyModal,
  DeidentifyAuditModal,
  DEIDENTIFY_SELECTION_LIMIT,
  retentionStatus
} from '../dataRetention';
import get from 'lodash.get';
import { hideCondition } from '../../helpers/hideHelper';
import {
  getListWithCustomFilterIfSysAdmin,
  overrideAvailableFilters
} from '../../helpers/listHelper';
import GridNavigationHelper from '../../helpers/GridNavigationHelper';
import { withRouterV6 } from '../../helpers/withRouterV6.jsx';
import BasePage from '../../components/common/basePageView';
import { CONTEXT_MENU_KEYS } from '../../constants/contextMenuEntries';
import config from '../../constants';
import {
  IS_EVENT_ADMIN,
  IS_EVENT_ORGANIZER_ADMIN,
  IS_CAMPAIGN_ORGANIZER_ADMIN,
  IS_SYSTEM_ADMIN_FILTER,
  ORGANIZATION_ID_FILTER
} from '../../constants/metadataConstants';
import { FeatureFlag } from '../../modules/featureflags';
import { grecaptcha } from '../../helpers/grecaptcha';
import { ExportDownloadProvider } from '../export-history';
import { withPageTitle } from '../../hocs';
import { WriteOnly } from '../../components/common/grid/WriteOnly';
import { contextTypeOptions } from '../../constants/roles';
import {
  SystemOnlyIcon,
  SystemOnlyPopup
} from '../../components/common/SystemOnlyBadge';

class AccountsPage extends Component {
  state = { retentionFlag: null, deidentify: null, auditFlagId: null };

  componentDidMount() {
    // Clear any stored return URL when entering this grid
    GridNavigationHelper.clearReturnUrlOnGridEntry();
    this.props.setView(this.props.match.params.tab);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.needGeneralRedirect) {
      this.generalRedirect();
      return false;
    }

    return true;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.tab !== this.props.match.params.tab) {
      this.props.clearListsState();
      this.props.setView(this.props.match.params.tab);
    }
  }

  handleMenuItemClick = (e, { name }) => {
    this.props.history.push(`/accounts/${name}`);
  };

  isViewSelected(view) {
    return this.props.selectedView === view;
  }

  onToggleColumnsChage = (toggleColumns) => {
    this.props.toggleColumnsChage(toggleColumns);
  };

  getExportValues = () => {
    if (this.isViewSelected(tabs.ALL_USERS)) {
      return this.props.allUsersList.request;
    }
    if (this.isViewSelected(tabs.ADMINS)) {
      return this.props.adminslist.request;
    }
    if (this.isViewSelected(tabs.FUNDRAISERS)) {
      return this.props.fundraiserslist.request;
    }
    if (this.isViewSelected(tabs.DONORS)) {
      return this.props.donorsList.request;
    }
    if (this.isViewSelected(tabs.RETENTION)) {
      return this.props.retentionList.request;
    }
    return {};
  };

  clearMessages = () => {
    this.props.clearRecordMessages('inviteAdminRecord');
  };

  isChooseTabButtonDisabled = () => {
    return (
      Record.isRecordLoading(this.props.adminslist) ||
      Record.isRecordLoading(this.props.fundraiserslist) ||
      Record.isRecordLoading(this.props.donorsList) ||
      (this.props.isSystemAdmin &&
        (Record.isRecordLoading(this.props.allUsersList) ||
          Record.isRecordLoading(this.props.retentionList)))
    );
  };

  getTabsButtons = () => {
    const isAllUsersView = this.isViewSelected(tabs.ALL_USERS);
    const isAdminView = this.isViewSelected(tabs.ADMINS);
    const isFundraisersView = this.isViewSelected(tabs.FUNDRAISERS);
    const isDonorsView = this.isViewSelected(tabs.DONORS);
    const isRetentionView = this.isViewSelected(tabs.RETENTION);

    const isChooseTabButtonDisabled = this.isChooseTabButtonDisabled();

    return (
      <Menu
        className="accounts-tab-buttons-group"
        style={{ margin: '0px', borderRight: '0px' }}
      >
        {this.props.isSystemAdmin && (
          <SystemOnlyPopup>
            <Menu.Item
              name={tabs.ALL_USERS}
              active={isAllUsersView}
              disabled={isChooseTabButtonDisabled}
              onClick={this.handleMenuItemClick}
            >
              <Translate value={i18nKeys.ALL_USERS_TAB_TITLE} />
              <SystemOnlyIcon />
            </Menu.Item>
          </SystemOnlyPopup>
        )}
        <Menu.Item
          name={tabs.ADMINS}
          active={isAdminView}
          disabled={isChooseTabButtonDisabled}
          onClick={this.handleMenuItemClick}
        >
          <Translate value={i18nKeys.ADMINS_TAB_TITLE} />
        </Menu.Item>
        <Menu.Item
          name={tabs.FUNDRAISERS}
          active={isFundraisersView}
          disabled={isChooseTabButtonDisabled}
          onClick={this.handleMenuItemClick}
        >
          <Translate value={i18nKeys.FUNDRAISERS_TAB_TITLE} />
        </Menu.Item>
        <Menu.Item
          name={tabs.DONORS}
          active={isDonorsView}
          disabled={isChooseTabButtonDisabled}
          onClick={this.handleMenuItemClick}
        >
          <Translate value={i18nKeys.DONORS_TAB_TITLE} />
        </Menu.Item>
        {this.props.isSystemAdmin && (
          <SystemOnlyPopup>
            <Menu.Item
              name={tabs.RETENTION}
              active={isRetentionView}
              disabled={isChooseTabButtonDisabled}
              onClick={this.handleMenuItemClick}
            >
              <Translate value={i18nKeys.RETENTION_TAB_TITLE} />
              <SystemOnlyIcon />
            </Menu.Item>
          </SystemOnlyPopup>
        )}
      </Menu>
    );
  };

  onInvitePanelDismiss = () => {
    this.props.changeInviteAdminPanelVisibility(false);
  };

  onInvitePanelOpen = () => {
    this.props.changeInviteAdminPanelVisibility(true);
  };

  getPanel = () => {
    const { Grid } = Common;
    const { Panel } = Grid.Managed;

    let entity = 'account';
    const view = this.props.selectedView;
    if (view === 'fundraisers') {
      entity += '/fundraiser';
    } else if (view === 'donors') {
      entity += '/donor';
    } else if (view === tabs.RETENTION) {
      entity = RETENTION_ENTITY;
    }

    return (
      <Panel name="right">
        <FeatureFlag feature="exportData">
          <ExportDownloadProvider entity={entity} version="v3">
            {({ open }) => (
              <Button onClick={() => open(this.getExportValues())}>
                Export
              </Button>
            )}
          </ExportDownloadProvider>
        </FeatureFlag>
        {this.isViewSelected(tabs.RETENTION) && this.props.isSystemAdmin && (
          <WriteOnly>{this.getDeidentifyButton()}</WriteOnly>
        )}
        {this.isViewSelected(tabs.ADMINS) &&
          !isOrgAdminRestricted(this.props.session) && (
            <WriteOnly>
              <Button
                id="inviteAdminButton"
                primary
                onClick={this.onInvitePanelOpen}
              >
                <Translate value={i18nKeys.INVITE_ADMIN_BUTTON} />
              </Button>
            </WriteOnly>
          )}
      </Panel>
    );
  };

  /**
   * Bulk de-identify. The cap is a UI limit only, so the operator reviews a small batch at a time
   * while the process is manual; the API takes an unbounded list for the eventual scheduled job.
   */
  getDeidentifyButton = () => {
    const selected = this.getSelectedRetentionItems();
    const overLimit = selected.length > DEIDENTIFY_SELECTION_LIMIT;

    // One shape in every state. The span exists because a disabled button swallows the events the
    // popup needs, and it stays even when the popup is off: swapping between a wrapped and an
    // unwrapped button changes which Semantic margin rule applies and visibly shifts the toolbar.
    return (
      <Popup
        disabled={!overLimit}
        content={I18n.t('account.account-detail.deidentify.limit', {
          limit: DEIDENTIFY_SELECTION_LIMIT
        })}
        trigger={
          <span className="deidentify-button">
            <Button
              negative
              disabled={selected.length === 0 || overLimit}
              onClick={this.onDeidentifySelected}
            >
              <Translate value={i18nKeys.RETENTION_DEIDENTIFY_BUTTON} />
            </Button>
          </span>
        }
      />
    );
  };

  /**
   * Custom column renderer for Grid.Managed
   * @param {string} column - column metadata
   * @param {string} value - column value to be displayed
   * @param {object} item - the row item data
   */
  columnRender(column, value, item) {
    if (column.id === adminColumns.STATUS) {
      return (
        <Table.Cell>
          <AccountStatus value={value} />
        </Table.Cell>
      );
    }
    if (column.id === adminColumns.ROLES) {
      return (
        <Table.Cell>
          <span className="capitalize">{value}</span>
        </Table.Cell>
      );
    }
    if (column.id === adminColumns.ADMIN_ACCESS) {
      const adminAccessInfo = getAdminAccessInfo(item, I18n);

      if (!adminAccessInfo.displayValue) {
        return <Table.Cell />;
      }

      if (adminAccessInfo.isMultiple) {
        return (
          <Table.Cell>
            <span>{adminAccessInfo.displayValue}</span>
            <Popup
              trigger={
                <Icon
                  name="info circle"
                  style={{ marginLeft: '5px', cursor: 'pointer' }}
                />
              }
              content={
                <div>
                  {adminAccessInfo.memberships.map((membership, index) => (
                    <div key={index}>{membership}</div>
                  ))}
                </div>
              }
              position="top center"
              wide="very"
              inverted
            />
          </Table.Cell>
        );
      }

      return (
        <Table.Cell>
          <span>{adminAccessInfo.displayValue}</span>
        </Table.Cell>
      );
    }
  }

  onClickImpersonate = (id) => {
    const tokenCallback = (token) => this.props.impersonateAdmin(id, token);
    grecaptcha(tokenCallback, 'SessionImpersonate');
  };

  isSysAdmin = (item) => {
    return item.isSysAdmin;
  };

  getContextMenu = () => {
    const params = {
      selectedView: this.props.selectedView
    };

    const isNotAdmin = (item) => {
      return hasActiveOrPastSystemAdminMembership(item) && !item.isAdmin;
    };

    return (
      <ContextMenu>
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.ACCOUNT.VIEW_PAGE.key}
          label={I18n.t(i18nKeys.VIEW_ACTION)}
          contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT.VIEW_PAGE}
          params={params}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.ACCOUNT.EDIT_PAGE.key}
          label={I18n.t(i18nKeys.EDIT_ACTION)}
          contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT.EDIT_PAGE}
          onClick={GridNavigationHelper.createEditClickHandler(
            this.props.setRedirectUrl,
            this.props.location
          )}
          params={params}
        />
        {this.props.isSystemAdmin && (
          <ContextMenu.Item
            key={CONTEXT_MENU_KEYS.ACCOUNT.IMPERSONATE.key}
            label={I18n.t(i18nKeys.IMPERSONATE_ACTION)}
            onClick={this.onClickImpersonate}
            isHiden={(item) => this.isSysAdmin(item) || isNotAdmin(item)}
            systemOnly
          />
        )}
        {this.props.isSystemAdmin && (
          <ContextMenu.Item
            key={CONTEXT_MENU_KEYS.ACCOUNT.AUDIT_TRAIL.key}
            label={I18n.t('campaign.performance.header.audit-trail')}
            contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT.AUDIT_TRAIL}
            isHiden={isNotAdmin}
            systemOnly
          />
        )}
      </ContextMenu>
    );
  };

  getRetentionContextMenu = () => {
    return (
      <ContextMenu>
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.ACCOUNT.RETENTION_VIEW_ACCOUNT.key}
          label={I18n.t(i18nKeys.VIEW_ACTION)}
          contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT.RETENTION_VIEW_ACCOUNT}
          isHiden={(item) => !item.accountId}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.ACCOUNT.RETENTION_VIEW_RULES.key}
          label={I18n.t(i18nKeys.RETENTION_VIEW_RULES_ACTION)}
          contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT.RETENTION_VIEW_RULES}
          onClick={(_id, item) => this.onViewRetentionRules(item)}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.ACCOUNT.RETENTION_DEIDENTIFY.key}
          label={I18n.t(i18nKeys.RETENTION_DEIDENTIFY_ACTION)}
          contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT.RETENTION_DEIDENTIFY}
          isHiden={(item) => item.status !== retentionStatus.flagged}
          onClick={(_id, item) => this.onDeidentify([item])}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.ACCOUNT.RETENTION_REVERT.key}
          label={I18n.t(i18nKeys.RETENTION_REVERT_ACTION)}
          contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT.RETENTION_REVERT}
          isHiden={(item) => item.status !== retentionStatus.anonymised}
          onClick={(_id, item) => this.onRevertDeidentify([item])}
        />
        <ContextMenu.Item
          key={CONTEXT_MENU_KEYS.ACCOUNT.RETENTION_AUDIT.key}
          label={I18n.t(i18nKeys.RETENTION_AUDIT_ACTION)}
          contextMenuOptions={CONTEXT_MENU_KEYS.ACCOUNT.RETENTION_AUDIT}
          isHiden={(item) => item.status !== retentionStatus.anonymised}
          onClick={(_id, item) => this.setState({ auditFlagId: item.id })}
        />
      </ContextMenu>
    );
  };

  /**
   * Rows the operator has ticked on the current page. Selection lives in the grid's Redux slice as an
   * isChecked flag per row, not in component state.
   */
  getSelectedRetentionItems = () => {
    const list = this.props.retentionList;
    const page = get(list, 'request.page');
    const rows = get(list, ['byPage', page]) || [];
    return rows.filter((row) => get(row, 'template.value.isChecked'));
  };

  toDeidentifySubjects = (items) =>
    items.map((item) => ({
      id: item.id,
      email: item.email,
      accountId: item.accountId ?? null
    }));

  onDeidentify = (items) => {
    this.setState({
      deidentify: {
        mode: 'deidentify',
        subjects: this.toDeidentifySubjects(items)
      }
    });
  };

  onRevertDeidentify = (items) => {
    this.setState({
      deidentify: { mode: 'revert', subjects: this.toDeidentifySubjects(items) }
    });
  };

  onDeidentifySelected = () => {
    this.onDeidentify(this.getSelectedRetentionItems());
  };

  onCloseDeidentify = () => {
    this.setState({ deidentify: null });
  };

  /**
   * Re-reads the current page so actioned rows show their new status. Also clears the checkboxes,
   * because the reducer resets the multi-select flags on a successful list load.
   */
  refreshRetentionList = () => {
    const request = get(this.props, 'retentionList.request');
    if (!request) {
      return;
    }
    this.props.retentionActionGrid.getListData(
      gridKeys.ACCOUNT_RETENTION,
      null,
      request,
      true
    );
  };

  getDeidentifyModal = () => {
    const state = this.state.deidentify;
    if (!state || state.subjects.length === 0) {
      return null;
    }
    return (
      <DeidentifyModal
        mode={state.mode}
        subjects={state.subjects}
        onClose={this.onCloseDeidentify}
        onCompleted={this.refreshRetentionList}
      />
    );
  };

  onViewRetentionRules = (item) => {
    this.setState({
      retentionFlag: {
        id: item.id,
        email: item.email,
        accountId: item.accountId
      }
    });
  };

  onCloseRetentionRules = () => {
    this.setState({ retentionFlag: null });
  };

  getRetentionRulesModal = () => {
    const flag = this.state.retentionFlag;
    if (!flag) {
      return null;
    }
    return (
      <Modal open onClose={this.onCloseRetentionRules} size="tiny" closeIcon>
        <Modal.Header>{flag.email}</Modal.Header>
        <Modal.Content>
          <RetentionPanel
            flagId={flag.id}
            hasAccount={flag.accountId != null}
          />
        </Modal.Content>
      </Modal>
    );
  };

  getInviteAdminPanel = () => {
    const { Grid } = Common;
    const { CenterPanel } = Grid.Managed;
    return (
      <CenterPanel>
        <InviteAdmin onDismissClick={this.onInvitePanelDismiss} />
      </CenterPanel>
    );
  };

  hideColumnCondition = (item) => {
    return hideCondition(
      this.props.isOrganizationAdmin,
      item,
      'path',
      'organization.name'
    );
  };

  generalRedirect = () => {
    this.props.history.push(config.DEFAULT_CAMPAIGNS_URL);
  };

  render() {
    if (
      Record.isRecordLoading(this.props.exportFileRecord) ||
      Record.isRecordLoading(this.props.impersonatedRecord)
    ) {
      return <Spinner />;
    }

    const { Grid } = Common;
    const panel = this.getPanel();
    const tabsButtons = this.getTabsButtons();
    const isAllUsersView = this.isViewSelected(tabs.ALL_USERS);
    const isAdminView = this.isViewSelected(tabs.ADMINS);
    const isFundraisersView = this.isViewSelected(tabs.FUNDRAISERS);
    const isDonorsView = this.isViewSelected(tabs.DONORS);
    const isRetentionView = this.isViewSelected(tabs.RETENTION);
    const contextMenu = this.getContextMenu();
    const centerPanel = this.getInviteAdminPanel();

    const allUsersListWithOrgFilter = getListWithCustomFilterIfSysAdmin(
      this.props.allUsersList,
      this.props.isSystemAdmin,
      []
    );

    const adminListWithOrgFilter = getListWithCustomFilterIfSysAdmin(
      this.props.adminslist,
      this.props.isSystemAdmin,
      []
    );

    // Apply org admin filter restrictions
    const allUsersList =
      this.props.isOrganizationAdmin && !this.props.isSystemAdmin
        ? overrideAvailableFilters(
            allUsersListWithOrgFilter,
            orgAdminsAvailableFilters
          )
        : allUsersListWithOrgFilter;

    const adminsList =
      this.props.isOrganizationAdmin && !this.props.isSystemAdmin
        ? overrideAvailableFilters(
            adminListWithOrgFilter,
            orgAdminsAvailableFilters
          )
        : adminListWithOrgFilter;

    return (
      <BasePage>
        <RecordResultMessage
          record={this.props.inviteAdminRecord}
          onDismiss={this.clearMessages}
        />
        <RecordResultMessage
          record={this.props.impersonatedRecord}
          onDismiss={() => this.props.clearRecordMessages('impersonatedRecord')}
        />
        <h1>
          <Translate value={i18nKeys.ACCOUNT_TITLE} />
        </h1>
        {tabsButtons}
        {isAllUsersView && (
          <Grid.Managed
            listKey={gridKeys.ACCOUNT_ALL_USERS}
            list={allUsersList}
            actions={this.props.allUsersActionGrid}
            search
            toggleColumns
            columnRender={this.columnRender}
            filtersButton
            hideColumn={this.hideColumnCondition}
          >
            {panel}
            {centerPanel}
            {contextMenu}
          </Grid.Managed>
        )}
        {isAdminView && (
          <Grid.Managed
            listKey={gridKeys.ACCOUNT_ADMINS}
            list={adminsList}
            actions={this.props.adminsActionGrid}
            search
            toggleColumns
            columnRender={this.columnRender}
            filtersButton
            hideColumn={this.hideColumnCondition}
          >
            {panel}
            {centerPanel}
            {contextMenu}
          </Grid.Managed>
        )}
        {isFundraisersView && (
          <Grid.Managed
            listKey={gridKeys.ACCOUNT_FUNDRAISERS}
            list={this.props.fundraiserslist}
            actions={this.props.fundraisersActionGrid}
            search
            toggleColumns
            filtersButton
            hideColumn={this.hideColumnCondition}
          >
            {panel}
            {contextMenu}
          </Grid.Managed>
        )}
        {isDonorsView && (
          <Grid.Managed
            listKey={gridKeys.ACCOUNT_DONORS}
            list={this.props.donorsList}
            actions={this.props.donorsActionGrid}
            search
            toggleColumns
            columnRender={this.columnRender}
            filtersButton
            hideColumn={this.hideColumnCondition}
          >
            {panel}
            {contextMenu}
          </Grid.Managed>
        )}
        {isRetentionView && this.props.isSystemAdmin && (
          <Grid.Managed
            listKey={gridKeys.ACCOUNT_RETENTION}
            list={this.props.retentionList}
            actions={this.props.retentionActionGrid}
            search
            toggleColumns
            filtersButton
          >
            {panel}
            {this.getRetentionContextMenu()}
          </Grid.Managed>
        )}
        {this.getRetentionRulesModal()}
        {this.getDeidentifyModal()}
        {this.state.auditFlagId != null && (
          <DeidentifyAuditModal
            flagId={this.state.auditFlagId}
            onClose={() => this.setState({ auditFlagId: null })}
          />
        )}
      </BasePage>
    );
  }
}

const mapState = ({ account, session }) => {
  const allUsersList = get(account, gridKeys.ACCOUNT_ALL_USERS);
  const donorsList = get(account, gridKeys.ACCOUNT_DONORS);
  const adminsList = get(account, gridKeys.ACCOUNT_ADMINS);
  const fundraisersList = get(account, gridKeys.ACCOUNT_FUNDRAISERS);
  const retentionList = get(account, gridKeys.ACCOUNT_RETENTION);

  return {
    allUsersList: allUsersList,
    donorsList: donorsList,
    retentionList: retentionList,
    adminslist: adminsList,
    fundraiserslist: fundraisersList,
    selectedView: account.selectedView,
    exportFileRecord: account.exportFileRecord,
    inviteAdminRecord: account.inviteAdminRecord,
    isSystemAdmin: session.isSystemAdmin,
    impersonatedRecord: account.impersonatedRecord,
    isOrganizationAdmin: get(session, 'isOrganizationAdmin'),
    needGeneralRedirect: get(session, 'needGeneralRedirect'),
    session
  };
};

const mapDispatch = (dispatch) => {
  var allUsersActions = {
    getMetadata: accountActions.getMetadata,
    getListData: accountActions.getListData,
    getListDataBySearchTerm: accountActions.getListDataBySearchTerm,
    toggleColumnsChange: accountActions.toggleColumnsChange
  };

  var adminsActions = {
    getMetadata: accountActions.getMetadata,
    getListData: accountActions.getListData,
    getListDataBySearchTerm: accountActions.getListDataBySearchTerm,
    toggleColumnsChange: accountActions.toggleColumnsChange
  };

  var fundraisersActions = {
    getMetadata: accountActions.getFundraiserMetadata,
    getListData: accountActions.getFundraiserListData,
    getListDataBySearchTerm: accountActions.getFundraiserListDataBySearchTerm,
    toggleColumnsChange: accountActions.toggleColumnsChange
  };

  var donorsActions = {
    getMetadata: accountActions.getDonorMetadata,
    getListData: accountActions.getDonorListData,
    getListDataBySearchTerm: accountActions.getDonorListDataBySearchTerm,
    toggleColumnsChange: accountActions.toggleColumnsChange
  };

  var retentionActions = {
    getMetadata: accountActions.getRetentionMetadata,
    getListData: accountActions.getRetentionListData,
    getListDataBySearchTerm: accountActions.getRetentionListDataBySearchTerm,
    toggleColumnsChange: accountActions.toggleColumnsChange,
    // Required by multi-select: the grid writes the whole page back through this on every tick.
    updateListData: accountActions.updateRetentionListData
  };

  const allUsersActionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    allUsersActions
  );
  const adminsActionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    adminsActions
  );
  const fundraisersActionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    fundraisersActions
  );
  const donorsActionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    donorsActions
  );
  const retentionActionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    retentionActions
  );

  return {
    allUsersActionGrid,
    adminsActionGrid,
    fundraisersActionGrid,
    donorsActionGrid,
    retentionActionGrid,
    setRedirectUrl: bindActionCreators(setRedirectUrl, dispatch),
    setView(view) {
      dispatch(accountActions.setView(view));
    },
    changeInviteAdminPanelVisibility(visible) {
      dispatch(accountActions.changeInviteAdminPanelVisibility(visible));
    },
    clearRecordMessages(recordKey) {
      dispatch(accountActions.clearRecordMessages(recordKey));
    },
    clearListsState() {
      dispatch(generalActions.clearListsReadyState());
    },
    impersonateAdmin(id, verificationToken = null) {
      dispatch(impersonateAdmin(id, verificationToken));
    }
  };
};

const titleResolver = (props) => {
  const tab = get(props, 'match.params.tab', 'all-users');
  let capitalizedTab = tab
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (l) => l.toUpperCase());
  return I18n.t('page-titles.accounts.list', { tab: capitalizedTab });
};

const AdminsListContainer = clear(
  withRouterV6(
    connect(mapState, mapDispatch)(withPageTitle(titleResolver)(AccountsPage))
  )
);
export default AdminsListContainer;
